import ContractList from './contract/ContractList';

export default function SimContractInfoTab({ simDetail }: any) {
  return (
    <div className={'sim-contract-info-tab mt-4'}>
      <ContractList documentData={simDetail?.documentData} />
    </div>
  );
}
